import React from "react";
import { useField } from "formik";
import { DateTimePicker } from "./DateTimePicker";

interface IFormikDateTimePickerProps {
  name: string;
  label: string;
  labelledById?: string;
  placeholder?: string;
  hideLabel?: boolean;
  asUtc?: boolean;
  disabled?: boolean;
  timeSteps?: { minutes: number };
  onChange?: (value: string) => void;
  onAccept?: (value: string) => void;
  required?: boolean;
}
export const FormikDateTimePicker: React.FC<IFormikDateTimePickerProps> = ({
  name,
  label,
  placeholder,
  hideLabel = false,
  disabled,
  asUtc = true,
  timeSteps,
  onChange,
  onAccept,
  required,
}) => {
  const [field, meta, helpers] = useField(name);
  const labelId = `date_time_picker_${name}`;

  const handleOnChange = (value: string) => {
    onChange?.(value);
  };

  const onAcceptChange = (value: string) => {
    onAccept?.(value);
  };
  return (
    <DateTimePicker
      label={label}
      labelId={labelId}
      placeholder={placeholder}
      hideLabel={hideLabel}
      disabled={disabled}
      value={field.value ? new Date(field.value) : null}
      isTouched={meta.touched}
      errorMessage={meta.error}
      asUtc={asUtc}
      timeSteps={timeSteps}
      onChange={handleOnChange}
      onAccept={onAcceptChange}
      setValue={(value) => helpers.setValue(value)}
      required={required}
    />
  );
};
